// ponytail: drop-in Box that extracts legacy system props (display, flex*,
// mt/mb/p*, width/height, etc.) and forwards them via sx={}. MUI v6+ stopped
// auto-forwarding system props on Box; unhandled props leak to DOM as React
// warnings. Wrapper hoists the known set into sx so 89 call sites keep working.
import React from "react";
import MuiBox from "@mui/material/Box";

const SYSTEM = new Set([
  "display", "flexDirection", "alignItems", "justifyContent", "flexWrap",
  "flexGrow", "flexShrink", "flex", "gap", "rowGap", "columnGap",
  "m", "mt", "mb", "ml", "mr", "mx", "my",
  "margin", "marginTop", "marginBottom", "marginLeft", "marginRight",
  "p", "pt", "pb", "pl", "pr", "px", "py",
  "padding", "paddingTop", "paddingBottom", "paddingLeft", "paddingRight",
  "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight",
  "borderRadius", "bgcolor", "color", "border", "borderTop", "borderBottom",
  "borderLeft", "borderRight", "boxShadow",
  "textAlign", "position", "top", "left", "right", "bottom", "zIndex",
  "overflow", "overflowX", "overflowY", "order",
  "fontSize", "fontWeight", "fontStyle", "lineHeight", "letterSpacing",
]);

export default function Box({ sx, ...props }) {
  const extracted = {};
  const rest = {};
  for (const key of Object.keys(props)) {
    if (SYSTEM.has(key)) extracted[key] = props[key];
    else rest[key] = props[key];
  }
  const mergedSx =
    Object.keys(extracted).length === 0
      ? sx
      : sx
        ? { ...extracted, ...(typeof sx === "object" && !Array.isArray(sx) ? sx : {}) }
        : extracted;
  return <MuiBox sx={mergedSx} {...rest} />;
}
